// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:path*\",\"regex\":\"^/(.+)$\",\"paramNames\":[\"path\"],\"hasOptionalPrefix\":false},{\"path\":\"/account/favourites/:id\",\"regex\":\"^/account/favourites/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/account/orders/:id\",\"regex\":\"^/account/orders/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/account\"},{\"path\":\"/account/favourites\"},{\"path\":\"/account/orders\"},{\"path\":\"/account/settings\"},{\"path\":\"/account/dashboard\"},{\"path\":\"/account/registration\"},{\"path\":\"/account/reset-password\"},{\"path\":\"/account/verify\"},{\"path\":\"/cart\"},{\"path\":\"/cart/thank-you\"},{\"path\":\"/compare\"},{\"path\":\"/search\"},{\"path\":\"/checkout/delivery-details\"},{\"path\":\"/checkout/shipping-and-payment\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.3";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import {
  browserTracingIntegration,
  captureRouterTransitionStart,
  init,
  replayIntegration,
} from '@sentry/nextjs';
import { ManagedRuntime } from 'effect';

import { getSentryConfigSyncClient } from '@rcprofi/config/sentry';

import { ClientLayer } from '@vs-shop/rcprofi/effect/runtime/layers/ClientLayer';
import { installEngineShellPlatformClient } from '@rcprofi/next/runtime/engineShellClientBootstrap';

performance.mark('app-init');

// Install the client ShellPlatform before this module's own config read below.
// The atom-read path is made deterministic separately by the same install from
// the root client boundary (AppRouterProvider) — see engineShellClientBootstrap.
installEngineShellPlatformClient();

const sentryConfig = getSentryConfigSyncClient();

init({
  ...sentryConfig,

  // Add optional integrations for additional features
  integrations: [browserTracingIntegration(), replayIntegration()],

  // Sample 10% of traces in production, 100% in development
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1,

  // Set tracePropagationTargets to control for which URLs distributed tracing should be enabled
  // TEMPORARY: Disabled trace propagation to system.rcprofi.com due to backend CORS missing headers:
  // - baggage (OpenTelemetry)
  // - sentry-trace (Sentry)
  // Re-enable after backend adds these headers to access-control-allow-headers
  tracePropagationTargets: [
    'localhost',
    /^\//,
    /^https:\/\/.*\.rcprofi\.cz/,
    /^https:\/\/.*\.rcprofi\.com/,
    /^http:\/\/.*\.rcprofi\.localhost/,
  ],

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export function onRouterTransitionStart(
  url: string,
  navigationType: 'push' | 'replace' | 'traverse'
) {
  captureRouterTransitionStart(url, navigationType);
}

if (typeof window !== 'undefined') {
  const browserRuntime = ManagedRuntime.make(ClientLayer);

  globalThis.__clientRuntime = browserRuntime;

  window.addEventListener('beforeunload', () => {
    void browserRuntime.dispose();
  });
}
